import { makeServicesTypes } from '@/core/container/makeServicesTypes'
import { enumKeysToArray } from '@/utils/enum'

enum SIGNUP_PHONE_VERIFICATION_SERVICES {
  SignupPhoneVerificationFormService,
  SignupPhoneVerificationCodeFormService,
  SignupPhoneVerificationResolver,
}

export type SignupPhoneVerificationServices = keyof typeof SIGNUP_PHONE_VERIFICATION_SERVICES

export const SIGNUP_PHONE_VERIFICATION_SERVICE_TYPES: Record<SignupPhoneVerificationServices, symbol> =
  makeServicesTypes<SignupPhoneVerificationServices>(
    enumKeysToArray<SignupPhoneVerificationServices>(SIGNUP_PHONE_VERIFICATION_SERVICES),
  )
